module.exports = __webpack_public_path__ + "static/img/6.e1159ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/3/sp/6.png
// module id = nvC2
// module chunks = 0